<template>
  <div class="lotto">
    <div class="top">
      <div class="row mx-0">
        <div class="col-4 col-sm-4 col-md-6 col-lg-9 d-flex align-items-center pb-md-0">
          <router-link to="/" class="mr-auto linkback">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </div>
        <div class="col-8 col-sm-8 col-md-6 col-lg-3 px-2"></div>
      </div>
    </div>
    <div class="content">
      <div class="card mb-1 w-100">
        <div
          class="card-header bg-dark text-light titlestyle d-flex justify-content-between align-items-center p-2"
        >
          <div>หวยเด่น</div>
          <div>
            <a :href="getSiteUrl + '/app.apk'" class="btn btn-outline-secondary btn-sm pb-0">
              <i class="fab fa-google-play"></i>
              <i class="fab fa-app-store-ios"></i>
              แทงหวยผ่านแอป
            </a>
          </div>
        </div>

        <div class="card-body p-1 titlestyle border border-dark">
          <div class="row px-3">
            <div
              class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
              v-for="item in lottos.lotto"
              v-bind:key="item.lottoName"
            >
              <router-link
                :to="item.lottoName != 'PingPongVIP' ? (item.lottoResultId ? '/lottery/government/' + item.lottoName + '/' + item.lottoResultId : '#') : '/lottery/PingPongVIP'"
              >
                <div
                  :class="['boxhuay', item.isBetAvailable ? '' : 'disabled']"
                  v-if="item.lottoName != 'PingPongVIP'"
                >
                  <div class="head-huay goldpattern align-items-stretch">
                    <div class="headflag">
                      <span :class="item.icon"></span>
                    </div>
                    <div class="headtxt flex-fill">
                      <div class="pt-1 pr-1">{{item.lottoDesc}}</div>
                      <div
                        class="subheadtxt subhead-huay"
                      ><!--{{item.lottoDate !== null && item.lottoDate != '' ? 'งวด ' + formatDate(item.lottoDate, "HH:mm") : '&nbsp;'}}--> {{item.lottoCloseTime !== null && item.lottoCloseTime != '' ? 'ปิดรับ ' + formatDate(item.lottoCloseDateTime, "HH:mm") : ''}}</div>
                    </div>
                  </div>
                  <div class="body-huay" v-if="item.isBetAvailable">
                    <span class="countdown style colorDefinition size_lg">
                      <vue-countdown
                        :time="getTimeLeft(item.lottoCloseDateTime)"
                        v-slot="{ days, hours, minutes, seconds }"
                        @end="getLottoAvailable()"
                      >
                        <span v-if="days > 0">
                          {{zeroPad(days, 2)}}
                          <sup>วัน</sup>&nbsp;&nbsp;
                        </span>
                        {{zeroPad(hours, 2)}}:{{zeroPad(minutes, 2)}}:{{zeroPad(seconds, 2)}}
                      </vue-countdown>
                    </span>
                  </div>
                  <div class="body-huay" v-else>
                    <span class="text-secondary">
                      <i class="far fa-calendar-times"></i> ยังไม่รับแทง
                    </span>
                  </div>
                </div>
                <div class="boxhuay" v-else>
                  <div class="head-huay head-yeekee align-items-stretch">
                    <div class="headflag">
                      <span class="bg-warning fullflag">
                        <i class="fab fa-slack-hash fa-spin"></i>
                      </span>
                    </div>
                    <div class="headtxt flex-fill">
                      <div class="pt-1 pr-1">จับยี่กี VIP</div>
                      <div class="subheadtxt subhead-huay">เปิดแทง 88 รอบ</div>
                    </div>
                  </div>
                  <div class="body-huay">
                    <span class="text-light">24 ชม.</span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="card mb-1 w-100">
          <div
            class="card-header bg-dark text-light titlestyle d-flex justify-content-between align-items-center p-2"
          >
            <div>หวยหุ้น</div>
            <div>
              <router-link :href="getSiteUrl + '/app.apk'" class="btn btn-outline-secondary btn-sm pb-0">
                <i class="fab fa-google-play"></i>
                <i class="fab fa-app-store-ios"></i> แทงหวยผ่านแอป
              </router-link>
            </div>
          </div>

          <div class="card-body p-1 titlestyle border border-dark">
            <div class="row px-3">
              <div
                class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
                v-for="item in lottos.lottoTradeMarket"
                v-bind:key="item.id"
              >
                <router-link :to="item.lottoResultId ? '/lottery/stock/' + item.lottoName + '/' + item.lottoResultId : '#'">
                  <div :class="['boxhuay', item.isBetAvailable ? '' : 'disabled']">
                    <div class="head-huay silverpattern align-items-stretch">
                      <div class="headflag">
                        <span :class="item.icon"></span>
                      </div>
                      <div class="headtxt flex-fill">
                        <div class="pt-1 pr-1">{{item.lottoDesc}}</div>
                        <div
                          class="subheadtxt subhead-huay"
                        ><!--{{item.lottoDate !== null && item.lottoDate != '' ? 'งวด ' + formatDate(item.lottoDate, "HH:mm") : '&nbsp;'}}--> {{item.lottoCloseTime !== null && item.lottoCloseTime != '' ? 'ปิดรับ ' + formatDate(item.lottoCloseDateTime, "HH:mm") : ''}}</div>
                      </div>
                    </div>
                    <div class="body-huay" v-if="item.isBetAvailable">
                      <span class="countdown style colorDefinition size_lg">
                        <vue-countdown
                          :time="getTimeLeft(item.lottoCloseDateTime)"
                          v-slot="{ days, hours, minutes, seconds }"
                          @end="getLottoAvailable()"
                        >
                          <span v-if="days > 0">
                            {{zeroPad(days, 2)}}
                            <sup>วัน</sup>&nbsp;&nbsp;
                          </span>
                          {{zeroPad(hours, 2)}}:{{zeroPad(minutes, 2)}}:{{zeroPad(seconds, 2)}}
                        </vue-countdown>
                      </span>
                    </div>
                    <div class="body-huay" v-else>
                      <span class="text-secondary">
                        <i class="far fa-calendar-times"></i> ยังไม่รับแทง
                      </span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>

        <!-- <div class="w-100 border border-top-0 mb-2"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  name: "LottoMenu",
  components: {
    VueCountdown
  },
  data() {
    return {
      lottos: []
    };
  },
  mounted() {
    this.getLottoAvailable();
  },
  methods: {
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    },
    zeroPad(num, places) {
      const zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    getTimeLeft(dt) {
      return moment(dt).diff(moment());
    },
    getLottoAvailable() {
      axios
        .post(
          this.getApiUrl + "/pingpong/lottoavailable",
          {
            username: this.getUsername,
            lottoType: 1
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.lottos = response.data.data;
          console.log("Get lottos", response);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl",
      getSiteUrl: "getSiteUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.countdown {
  font-family: "Gugi", cursive, SukhumvitReg;
}

.lotto {
  .top {
    border: 1px #333 solid;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: block;
    margin-top: 10px;
    padding: 10px 0;
    background: #222;
    color: lightgoldenrodyellow;
    line-height: 1;

    .linkback {
      color: gray;
      text-decoration: none;
    }
  }

  .content {
    border: 1px #333 solid;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #eee;
    display: block;
    padding: 5px 5px;
    margin-bottom: 10px;

    .card-body {
      a {
        text-decoration: none;
      }

      .titlestyle {
        font-size: 120%;
        line-height: 1;
      }

      .boxhuay {
        width: 100%;
        display: block;
        margin: 0 auto;
        background: white;
        border-radius: 3px;
        overflow: hidden;
        border: rgba(0, 0, 0, 0.5) 1px solid;

        &.disabled {
          -webkit-filter: grayscale(1) opacity(0.7);
          filter: grayscale(1) opacity(0.7);
        }

        .goldpattern {
          background: url(../assets/images/gold-white.jpg) top center;
          background-size: 100%;
        }

        .silverpattern {
          background: url(../assets/images/silver-pattern.jpg) top center;
          background-size: 100%;
        }

        .head-huay {
          width: 100%;
          height: 100%;
          border-bottom: 1px solid rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: stretch;

          .headflag {
            width: 65px;
            overflow: hidden;
            align-self: stretch;
            border-right: 1px solid rgba(0, 0, 0, 0.5);

            span {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0;
            }

            span > i {
              font-size: 25px;
              color: rgba(0, 0, 0, 0.8);
            }

            .fullflag {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0;
              background-size: cover;
              height: 100%;
              width: 100%;
            }

            .flag-icon {
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              position: relative;
              display: inline-block;
              width: 1.33333333em;
              line-height: 1em;
              height: 100%;
              width: 100%;
            }

            .flag-icon-th {
              background-image: url(../assets/flags/4x3/th.svg);
            }

            .flag-icon-vn {
              background-image: url(../assets/flags/4x3/vn.svg);
            }

            .flag-icon-my {
              background-image: url(../assets/flags/4x3/my.svg);
            }

            .flag-icon-la {
              background-image: url(../assets/flags/4x3/la.svg);
            }

            .flag-icon-gsb {
              background-color: #f90a86;
            }

            .flag-icon-baac {
              background-color: #13007d;
            }

            .flag-icon-jp {
              background-image: url(../assets/flags/4x3/jp.svg);
            }

            .flag-icon-hk {
              background-image: url(../assets/flags/4x3/hk.svg);
            }

            .flag-icon-kr {
              background-image: url(../assets/flags/4x3/kr.svg);
            }

            .flag-icon-sg {
              background-image: url(../assets/flags/4x3/sg.svg);
            }

            .flag-icon-in {
              background-image: url(../assets/flags/4x3/in.svg);
            }

            .flag-icon-eg {
              background-image: url(../assets/flags/4x3/eg.svg);
            }

            .flag-icon-ru {
              background-image: url(../assets/flags/4x3/ru.svg);
            }

            .flag-icon-gb {
              background-image: url(../assets/flags/4x3/gb.svg);
            }

            .flag-icon-de {
              background-image: url(../assets/flags/4x3/de.svg);
            }

            .flag-icon-cn {
              background-image: url(../assets/flags/4x3/cn.svg);
            }

            .flag-icon-tw {
              background-image: url(../assets/flags/4x3/tw.svg);
            }

            .flag-icon-us {
              background-image: url(../assets/flags/4x3/us.svg);
            }
            .flag-icon-eth {
              background-image: url(../assets/flags/4x3/eth.svg);
              background-size: contain;
            }
            .flag-icon-bitcoin {
              background-image: url(../assets/flags/4x3/bitcoin.svg);
              background-size: contain;
            }
            .flag-icon-apple {
              background-image: url(../assets/flags/4x3/apple.svg);
              background-size: calc(100% - 30px);

              @media screen and (max-width: 575px) {
                background-size: calc(100% - 5px);
              }
            }
            .flag-icon-tesla {
              background-image: url(../assets/flags/4x3/tesla.svg);
              background-size: contain;
            }
          }

          .headtxt {
            text-align: right;
            /* text-shadow: rgb(0 0 0 / 90%) 0px 0px 3px; */
            color: rgb(255, 255, 255);
            text-shadow: rgb(0 0 0) 2px 0px 0px,
              rgb(0 0 0) 1.75517px 0.958851px 0px,
              rgb(0 0 0) 1.0806px 1.68294px 0px,
              rgb(0 0 0) 0.141474px 1.99499px 0px,
              rgb(0 0 0) -0.832294px 1.81859px 0px,
              rgb(0 0 0) -1.60229px 1.19694px 0px,
              rgb(0 0 0) -1.97998px 0.28224px 0px,
              rgb(0 0 0) -1.87291px -0.701566px 0px,
              rgb(0 0 0) -1.30729px -1.5136px 0px,
              rgb(0 0 0) -0.421592px -1.95506px 0px,
              rgb(0 0 0) 0.567324px -1.91785px 0px,
              rgb(0 0 0) 1.41734px -1.41108px 0px,
              rgb(0 0 0) 1.92034px -0.558831px 0px;
            letter-spacing: 0.04em;

            .subhead-huay {
              min-height: 23px;
            }
          }

          .subheadtxt {
            display: block;
            padding: 2px 2px 1px 2px;
            width: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: gold;
            text-shadow: rgb(0 0 0) 1px 1px 2px;
            font-size: 80%;
          }

          @media screen and (max-width: 576.98px) {
            .headtxt {
              font-size: 16px;
              line-height: 16px;
            }
            .headflag {
              width: 35px;
            }
            .body-huay {
              font-size: 18px;
              padding: 8px 0;
            }
          }
          @media screen and (max-width: 320px) {
            .headtxt {
              font-size: 14px;
              line-height: 14px;
            }
            .headflag {
              width: 30px;
            }
            .subhead-huay {
              font-size: 80%;
              letter-spacing: normal;
            }
          }
        }

        .head-yeekee {
          background: url(../assets/images/gold-black.jpg) top center;
          background-size: 100%;
        }

        .body-huay {
          width: 100%;
          display: block;
          background: #252525;
          text-align: right;
          color: white;
          padding: 8px 5px;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
